import React from 'react';
import PropTypes from 'prop-types';

const DistributionCards = ({ data }) => {
    if (!data) return null;

    const renderDistributionRow = (title, percentage, values) => (
        <div className="distribution-row">
            <h4>{title} ({percentage})</h4>
            <div className="distribution-values">
                <div className="value-card">
                    <span className="label">Current</span>
                    <span className="value">${values.current}</span>
                </div>
                <div className="value-card">
                    <span className="label">Projected</span>
                    <span className="value">${values.projected}</span>
                </div>
                <div className="value-card">
                    <span className="label">Maximum</span>
                    <span className="value">${values.maximum}</span>
                </div>
            </div>
        </div>
    );

    return (
        <div className="chart-container distribution-cards">
            <h3>Prize Distribution ($1 per loss)</h3>
            <div className="distribution-grid">
                <div className="distribution-position">
                    {renderDistributionRow("First Place", "80%", {
                        current: data.current.first,
                        projected: data.projected.first,
                        maximum: data.maximum.first
                    })}
                    {renderDistributionRow("Second Place", "15%", {
                        current: data.current.second,
                        projected: data.projected.second,
                        maximum: data.maximum.second
                    })}
                    {renderDistributionRow("Third Place", "5%", {
                        current: data.current.third,
                        projected: data.projected.third,
                        maximum: data.maximum.third
                    })}
                </div>
            </div>
        </div>
    );
};

DistributionCards.propTypes = {
    data: PropTypes.shape({
        current: PropTypes.shape({
            first: PropTypes.number,
            second: PropTypes.number,
            third: PropTypes.number
        }),
        projected: PropTypes.shape({
            first: PropTypes.number,
            second: PropTypes.number,
            third: PropTypes.number
        }),
        maximum: PropTypes.shape({
            first: PropTypes.number,
            second: PropTypes.number,
            third: PropTypes.number
        })
    })
};

export default DistributionCards;
